import {
  combineTranslationBundles,
  Localization,
  loadPackageTranslations,
  setupTranslationLanguageSync,
  type TranslationModule,
  type LanguageCode
} from '@hconnect/common/localization-loaders'
import {uikitTranslations} from '@hconnect/uikit'
import {areaDashboardWidgetTranslations} from '@widgets/area-dashboard'
import {commonFiltersWidgetTranslations} from '@widgets/common-filters'
import {downtimeAnalyticsWidgetTranslations} from '@widgets/downtime-analytics'
import {eventsSummaryWidgetTranslations} from '@widgets/events-summary'
import {expertSystemWidgetTranslations} from '@widgets/expert-system'
import {kmsWidgetTranslations} from '@widgets/kms'
import {kpisWidgetTranslations} from '@widgets/kpis'
import {pomCompletionWidgetTranslations} from '@widgets/pom-completion'
import {runningTimesWidgetTranslations} from '@widgets/running-times'
import {shiftEventDetailsWidgetTranslations} from '@widgets/shift-event-details'
import {shiftEventFiltersWidgetTranslations} from '@widgets/shift-event-filters'
import {shiftTasksWidgetTranslations} from '@widgets/shift-tasks'
import {tasksWidgetTranslations} from '@widgets/tasks'
import i18n from 'i18next'

const isDev = process.env.NODE_ENV === 'development'
async function loader(filename: string) {
  isDev && console.info(`Load Translation [${filename}]`)
  try {
    return (await import(`./${filename}`)).default
  } catch (err) {
    isDev && console.error(`Could not load Translation [${filename}]`, err)
    return {err}
  }
}

// Widget translations are kept here intentionally as a temporary solution
// for pages that are not yet fully extracted but already use extracted widgets.
// Once those pages are extracted into feature packages, their widget translations
// should be loaded via FeatureTranslationsLoader at the route level.
const externalPackageTranslations: TranslationModule[] = combineTranslationBundles([
  uikitTranslations,
  commonFiltersWidgetTranslations,
  downtimeAnalyticsWidgetTranslations,
  expertSystemWidgetTranslations,
  runningTimesWidgetTranslations,
  tasksWidgetTranslations,
  kpisWidgetTranslations,
  kmsWidgetTranslations,
  eventsSummaryWidgetTranslations,
  shiftTasksWidgetTranslations,
  shiftEventDetailsWidgetTranslations,
  shiftEventFiltersWidgetTranslations,
  pomCompletionWidgetTranslations,
  areaDashboardWidgetTranslations
])

const supportedLngs: LanguageCode[] = [
  'de-DE',
  'en-US',
  'fr-FR',
  'hu-HU',
  'it-IT',
  'kk-KZ',
  'no-NO',
  'nl-NL',
  'pl-PL',
  'ro-RO',
  'ru-RU',
  'sv-SE',
  'th-TH'
]

export async function initLocalization() {
  await Localization({
    fallbackLng: 'en-US',
    supportedLngs,
    detection: {
      order: ['localStorage', 'cookie', 'navigator']
    },
    // when a translation is empty string "" this will result in using the fallback language translation
    returnEmptyString: false,
    backend: {
      loader
    }
  })

  void loadPackageTranslations(i18n, externalPackageTranslations, {debug: isDev})
  setupTranslationLanguageSync(i18n, externalPackageTranslations, {debug: isDev})
}
